<template>
  <v-app style="background-color: #ddf7ff">
      <Toolbar />
      <router-view></router-view>
      <Footer/>
    </v-app>
</template>

<script>
import Toolbar from './ToolbarEmail.vue'
import Footer from './Footer.vue'
export default {
  name: 'portal_layout',
  components: {
    Toolbar,
    Footer
  }
}
</script>
